import Vue from 'vue'
import Router from 'vue-router'
import MainView from '@/components/MainView'
import NewMainView from '@/components/NewMainView'
import FileView from '@/components/file/FileView'
import MessageView from '@/components/message/MessageView'
import ExternalShareLink from '@/components/shareLink/ExternalShareLink'
// import CollabItem from '@/components/collab/CollabItem'
import CollabRolesDetail from '@/components/collab/CollabRolesDetail'
import WxPreviewView from '@/components/wx/WxPreviewView'
import WxSharePreviewView from '@/components/wx/WxSharePreviewView'
import OpenPlatformUploadFiles from '@/components/file/OpenPlatformUploadFiles'
import PromotionSales from '@/components/promotion/PromotionSales'
import CollectionView from '@/components/embedAppPage/collection/CollectionView'
import WorkflowView from '@/components/embedAppPage/workflow/WorkflowView'
import Introduce from '@/components/introduce/Introduce'
import Doclib from '@/components/doclib/index/Doclib'
import DoclibFileList from '@/components/doclib/file/DoclibFileList'
import DoclibSearch from '@/components/doclib/file/DoclibSearch'
import DoclibPreview from '@/components/doclib/file/DoclibPreview'
import config from '../config'

Vue.use(Router)

let base = '/'

const pathnameArr = location.pathname.split('/').filter(item => item)
if (pathnameArr[0] === 'h5') {
  base = '/h5/'
  config.apiUrl = ''
  config.openUrlPrefix = ''
} else {
  // config.openRequestUrl = ''
}

export default new Router({
  mode: 'history',
  base,
  routes: [
    {
      path: '/navigateToMiniApp',
      name: 'NavigateToMiniApp',
      component: () => import('@/components/NavigateToMiniApp')
    },
    {
      path: '/',
      component: MainView,
      redirect: '/files/frequent',
      children: [
        {
          path: ':module(files)/:space/:id?',
          name: 'FileView',
          component: FileView
        },
        {
          path: ':module(message)/:type?/:id?',
          name: 'MessageView',
          component: MessageView
        },
        {
          path: ':module(select_files|select_destination)/:space?/:id?',
          name: 'OpenView',
          component: FileView
        },
        {
          path: '/:module(open_upload)',
          name: 'OpenUpload',
          component: OpenPlatformUploadFiles
        },
        {
          path: '/:module(open_preview)',
          name: 'OpenView'
        },
        {
          path: '/:module(share)/:unique_name',
          name: 'ExternalShare',
          component: ExternalShareLink
        },
        {
          path: '/:module(collab)/:type',
          name: 'collab',
          component: CollabRolesDetail
        }
      ]
    },
    {
      path: '/inapp',
      component: NewMainView,
      children: [
        {
          path: '/inapp/:module(collection)/:id',
          name: 'CollectionView',
          component: CollectionView
        },
        // {
        //   path: '/inapp/:module(comment)/:id?',
        //   name: 'NewCommentView',
        //   component: CommentView
        // },
        // {
        //   path: '/inapp/:module(review)/:id?',
        //   name: 'ReviewView',
        //   component: ReviewView
        // },
        {
          path: '/inapp/:module(workflow)/:id',
          name: 'WorkflowView',
          component: WorkflowView
        }
      ]
    },
    // {
    //   path: '/inapp/collection/:id',
    //   name: 'CollectionView',
    //   component: CollectionView
    // },
    // {
    //   path: '/inapp/workflow/:id',
    //   name: 'WorkflowView',
    //   component: WorkflowView
    // },
    {
      path: '/wx/preview/:file_id',
      component: WxPreviewView
    },
    {
      path: '/wx/share/preview/:unique_name',
      component: WxSharePreviewView
    },
    {
      path: '/promotion',
      name: 'PromotionSales',
      component: PromotionSales
    },
    {
      path: '/introduce',
      component: Introduce
    },
    {
      path: '/doclib',
      component: NewMainView,
      children: [
        {
          path: '/doclib/list',
          name: 'Doclib',
          component: Doclib
        },
        {
          path: '/doclib/files/:library_id',
          name: 'DoclibFileList',
          component: DoclibFileList
        },
        {
          path: '/doclib/search',
          name: 'DoclibSearch',
          component: DoclibSearch
        },
        {
          path: '/doclib/files/:library_id/preview',
          name: 'DoclibPreview',
          component: DoclibPreview
        }
      ]
    }
  ]
})
